import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from '../../components/Loading';
import { FiArrowLeftCircle, FiList } from 'react-icons/fi';
import { loadHistoryRequest } from '../../app/store/requests/thunk';
import { TableExpander } from '../../components/tables/TableExpander';
import { loadEvidences } from '../../app/store/evidences/thunk';
import { ModalGallery } from '../../components/ModalGallery';

export const HistoryRequest = ({ navigateTo, data }) => {

    const dispatch = useDispatch();
    const { isLoading, detailRequest, detailItems, msg } = useSelector(state => state.requests);
    const { evidencesItems } = useSelector(state => state.evidences);
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        dispatch(loadHistoryRequest(data?.id || 0));
        dispatch(loadEvidences(data?.id || 0));
    }, []);

    const handleCloseModal = () => {
        setShowModal(false);
        //   // setSearchType(null);
    };
    const purcharseOrder = detailRequest;


    const listProductsColumns = [
        {
            header: 'SKU',
            dataIndex: 'SKU',
            classHeader: 'text-start',
            classRow: 'text-start'
        },
        {
            header: 'CATEGORIA',
            dataIndex: 'CATEGORY',
            classHeader: 'text-start',
            classRow: 'text-start'
        },
        {
            header: 'MARCA',
            dataIndex: 'BRAND',
            classHeader: 'text-start',
            classRow: 'text-start'
        },
        {
            header: 'PRODUCTO',
            dataIndex: 'NAME_PRODUCT',
            classHeader: 'text-center',
            classRow: 'text-center'
        },
        {
            header: 'DESCRIPCION',
            dataIndex: 'DESCRIPTION_PRODUCT',
            classHeader: 'text-start',
            classRow: 'text-start'
        },

        {
            header: 'CANT. REQUERIDA',
            dataIndex: 'QUANTITY_REQUESTED',
            classHeader: 'text-center',
            classRow: 'text-center'
        },
        {
            header: 'CANT. APROBADA',
            dataIndex: 'QUANTITY_APPROVED',
            classHeader: 'text-center',
            classRow: 'text-center'
        },
        {
            header: 'CANT. RECIBIDA',
            dataIndex: 'QUANTITY_RECEIVED_TOTAL',
            classHeader: 'text-center',
            classRow: 'text-center'
        },
        // {
        //     header: 'CANT. RECIBIDA',
        //     dataIndex: 'QUANTITY_RECEIVED_TOTAL',
        //     classHeader: 'text-center',
        //     classRow: 'text-center'
        // }
    ];


    const receivingColumns = [
        {
            header: 'COMENTARIOS | OBSERVACIONES',
            dataIndex: 'NOTES'
        },
        {
            header: 'CANT. RECIBIDA',
            dataIndex: 'QUANTITY_RECEIVED',
            classHeader: 'text-center',
            classRow: 'text-center'
        },
        {
            header: 'FECHA RECIBIDO',
            dataIndex: 'DATE',
            classHeader: 'text-center',
            classRow: 'text-center'
        },
        {
            header: 'HORA RECIBIDO',
            dataIndex: 'HOUR',
            classHeader: 'text-center',
            classRow: 'text-center'
        },

    ];

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (

        <>
            {showModal && (<ModalGallery onClose={handleCloseModal} images={evidencesItems} closeOnEscape={true} closeOnBackdrop={true} />)}
            <div className='row'>
                <div className='col-12 mb-3'>
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center  ">
                        <div className="d-flex mb-1">
                            <button className="btn btn-outline-dark border-0" onClick={() => navigateTo('list')}>
                                <FiArrowLeftCircle size={23} />
                            </button>
                            <h1 className="h4 fw-bold mt-2"> | Detalles de Orden: {purcharseOrder?.NUMBER}</h1>
                        </div>
                    </div>
                </div>

                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                    <div className="card">
                        <div className="card-header border-bottom">
                            <h5 className="card-title mb-0 fw-bold text-dark">Detalle de Orden</h5>
                        </div>
                        <div className="card-body">
                            <div className="mb-2">
                                <label className="form-label">Capturo:</label>
                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.USERNAME_REGISTER} />
                            </div>

                            <div className='d-flex'>
                                <div className="mb-2 me-3">
                                    <label className="form-label">Fecha (Registro):</label>
                                    <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.DATEREGISTER} />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Hora (Registro):</label>
                                    <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.HOURREGISTER} />
                                </div>
                            </div>
                            {
                                purcharseOrder?.STATUSID === '6' && (
                                    <>
                                        <div className="mb-2 mt-1">
                                            <label className="form-label">Recibio (Completo):</label>
                                            <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.USERNAME_COMPLETED} />
                                        </div>
                                        <div className='d-flex'>
                                            <div className="mb-2 me-3">
                                                <label className="form-label">Fecha (Completo):</label>
                                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.DATECOMPLETED} />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label">Hora (Completo):</label>
                                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.HOURCOMPLETED} />
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                            {
                                purcharseOrder?.STATUSID === '7' && (
                                    <>
                                        <div className="mb-2 mt-1">
                                            <label className="form-label">Cancelo:</label>
                                            <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.USERNAME_CANCELED} />
                                        </div>
                                        <div className='d-flex'>
                                            <div className="mb-2 me-3">
                                                <label className="form-label">Fecha (Cancelacion):</label>
                                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.DATECANCELED} />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label">Hora (Cancelacion):</label>
                                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.HOURCANCELED} />
                                            </div>
                                        </div>
                                    </>
                                )
                            }

                            <div className="mb-2">
                                <label className="form-label">Estado:</label>
                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.STATUSDESC} />
                            </div>
                            {evidencesItems?.length > 0 && (
                                <div className='text-center'>
                                    <button type="button" className="btn btn-outline-dark" onClick={() => { setShowModal(true); }} >
                                        <FiList size={22} /> Ver evidencias registradas
                                    </button>
                                </div>
                            )}

                        </div>
                    </div>
                </div>

                <div className='col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9'>
                    <div className="card">
                        <div className="card-header border-bottom">
                            <h5 className="card-title fw-bold text-dark mb-0">Listado de productos:</h5>
                        </div>
                        <div className="card-body">
                            <TableExpander
                                columns={listProductsColumns}
                                data={detailItems}
                                rowKey="IDREQUESTITEM"
                                expandable={true}
                                multiExpand={false}          // 🔁 false = acordeón | true = multi-expand
                                expandField="receivings"
                                expandColumns={receivingColumns}
                                placeholderSearch="Buscar producto..."
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
